<div id="resolution-popup" class="popup" style="display: none;">
  <div class="popup-content">
    <span class="close" (click)="closePopup()">&times;</span>
    <img [src]="imageSrc" />
    <p class="m-0">We recommend a screen resolution of at least <span class="text-bold">{{innerWidth}}x{{innerHeight}}</span> for the best experience.</p>
    <div class="row">
      <div class="col-6 offset-3 text-center">
        <fn-button type="primary" btnClass="btn-sm btn-round width-150px" (click)="closePopup()" text="Ok"></fn-button>
      </div>
    </div>
  </div>
</div>